import { createApi } from "@reduxjs/toolkit/query/react";
import { extendedBaseQuery } from "../basequery";

export const topicsApi = createApi({
  reducerPath: "topicsApi",
  baseQuery: extendedBaseQuery,
  tagTypes: ["Topics", "Organization"],
  endpoints: (builder) => ({
    getTopics: builder.query({
      query: (params) => {
        const query = {};
        if (params?.skip) query.skip = params.skip;
        if (params?.limit) query.limit = params.limit;
        if (params?.search) query.search = params.search;
        if (params?.filter) query.filter = params.filter;
        if (params?.sortBy) query.sortBy = params.sortBy;
        if (params?.orderBy) query.orderBy = params.orderBy;
        return {
          url: `topics/all?${new URLSearchParams(query).toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Topics"],
    }),
    // getOrganization: builder.query({
    //   query: (id) => ({
    //     url: `organization/${id}`,
    //     method: "GET",
    //   }),
    //   providesTags: ["Organization"],
    // }),
    createTopics: builder.mutation({
      query: (body) => ({
        url: "topics/create",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Topics"],
    }),
    pushNotification: builder.mutation({
      query: (body) => ({
        url: "topics/push-notification",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Topics"],
    }),
    updateTopic: builder.mutation({
      query: (body) => ({
        url: `organization/${body.id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["Organization"],
    }),
    deleteTopic: builder.mutation({
      query: (id) => ({
        url: `organization/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Organization"],
    }),
    uploadOrganizationLogo: builder.mutation({
      query: (file) => {
        const formData = new FormData();
        formData.append("file", file);
        return {
          url: "uploads/single",
          method: "POST",
          body: formData,
        };
      },
    }),
    organizationDeviceInfo: builder.query({
      query: (id) => `organization/deviceInfo?organizationId=${id}`,
      providesTags: ["Organization"],
    }),
  }),
});

export const {
  useGetTopicsQuery,
  useCreateTopicsMutation,
  usePushNotificationMutation,
  useUpdateTopicMutation,
  useDeleteTopicMutation,
  useUploadOrganizationLogoMutation,
  useOrganizationDeviceInfoQuery,
} = topicsApi;
